export interface notesHistory {
  notesId: number;
  contactName: string;
  contactId: string;
  contactTrackingId: string;
  agentName: string;
  subTitle: string;
  noteContent: string;
  expandedMaxContent: boolean;
  noteTitle: string;
  date: string;
  time: string;
}

export const notesHistoryListData: notesHistory[] = [
  {
    notesId: 0,
    contactName: 'Liam Davis',
    contactId: '(253) 895-9889',
    contactTrackingId: '423-INCL-0246',
    agentName: 'Agent Smith',
    time: '8:32pm',
    subTitle: 'The customer seems to be unhappy with the luggage situation...',
    noteContent: `The customer seems to be unhappy with the luggage situation.We have had multiple conversations about this but he doesn't want to make any concessions. I have elevated it to a supervisor and we will see how he responds.`,
    expandedMaxContent: false,
    noteTitle: 'Customer Is Unhappy',
    date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
  },
  {
    notesId: 1,
    contactName: 'Liam Davis',
    contactId: '(253) 895-9889',
    contactTrackingId: '423-INCL-0246',
    agentName: 'Agent Smith',
    time: '8:00pm',
    subTitle: 'The customer seems to be unhappy with the luggage situation...',
    noteContent: `The customer seems to be unhappy with the luggage situation.We have had multiple conversations about this but he doesn't want to make any concessions. I have elevated it to a supervisor and we will see how he responds.`,
    expandedMaxContent: false,
    noteTitle: 'Customer Would Like His Luggage',
    date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    notesId: 2,
    contactName: 'Liam Davis',
    contactId: '(253) 895-9889',
    contactTrackingId: '423-INCL-0246',
    agentName: 'Agent Smith',
    time: '6:53pm',
    subTitle: 'Agent had to update contact details regarding recent transaction...',
    noteContent: `The customer seems to be unhappy with the luggage situation.We have had multiple conversations about this but he doesn't want to make any concessions. I have elevated it to a supervisor and we will see how he responds.`,
    expandedMaxContent: false,
    noteTitle: 'Customer Can’t Find Luggage',
    date: new Date(
      new Date().setMonth(new Date().getMonth() - 1)
    ).toISOString(),
  },
  {
    notesId: 3,
    contactName: 'Liam Davis',
    contactId: '(253) 895-9889',
    contactTrackingId: '423-INCL-0246',
    agentName: 'Agent Smith',
    time: '8:32pm',
    subTitle:
      'Agent had to update contact details regarding recent transaction...',
    noteContent: `The customer seems to be unhappy with the luggage situation.We have had multiple conversations about this but he doesn't want to make any concessions. I have elevated it to a supervisor and we will see how he responds.`,
    expandedMaxContent: false,
    noteTitle: 'Edit Made to Contact',
    date: new Date(
      new Date().setMonth(new Date().getMonth() - 1)
    ).toISOString(),
  },
  {
    notesId: 4,
    contactName: 'Liam Davis',
    contactId: '(253) 895-9889',
    contactTrackingId: '423-INCL-0246',
    agentName: 'Agent Smith',
    time: '8:32pm',
    subTitle: 'The customer seems to be unhappy with the luggage situation...',
    noteContent: `The customer seems to be unhappy with the luggage situation.We have had multiple conversations about this but he doesn't want to make any concessions. I have elevated it to a supervisor and we will see how he responds.`,
    expandedMaxContent: false,
    noteTitle: 'Customer Wants to Book Travel',
    date: new Date(
      new Date().setMonth(new Date().getMonth() - 3)
    ).toISOString(),
  },
  {
    notesId: 5,
    contactName: 'Liam Davis',
    contactId: '(253) 895-9889',
    contactTrackingId: '423-INCL-0246',
    agentName: 'Agent Smith',
    time: '8:00pm',
    subTitle: 'The customer seems to be unhappy with the luggage situation...',
    noteContent: `The customer seems to be unhappy with the luggage situation.We have had multiple conversations about this but he doesn't want to make any concessions. I have elevated it to a supervisor and we will see how he responds.`,
    expandedMaxContent: false,
    noteTitle: 'Agent Misspoke on Offer',
    date: new Date(
      new Date().setMonth(new Date().getMonth() - 3)
    ).toISOString(),
  },
];
